<!-- ===== CLEAN DASHBOARD HEADER ===== -->
<header class="clean-dashboard-header">
  <div class="header-main">
    <div class="header-left">
      <div class="header-icon">
        <i class="pi pi-chart-line"></i>
      </div>
      <div class="header-text">
        <h1>TDF &gt; Dashboard</h1>
        <p>TDF Proposal Monitoring &amp; Decision Analytics</p>
      </div>
    </div>
    <div class="header-right d-flex gap-3">
      <button class="clean-primary-btn" (click)="navigateto()">
        <i class="pi pi-plus-circle"></i>
        Initiate New Proposal
      </button>
      <button class="seek-proposal-btn" (click)="displayDialog = true">
        <i class="pi pi-plus"></i>
        Seek Proposal
      </button>
    </div>
  </div>
</header>

<!-- ===== TOP KPI SUMMARY (TDF – no sub schemes) ===== -->
<section class="dashboard-top-cards" aria-label="Summary metrics">
  <app-summary-metrics
    labelSet="tdf"
    [totalContracts]="totalContracts"
    [totalProposals]="totalProposals"
    [totalSubSchemes]="0"
    [totalPreLaunch]="totalPreLaunch"
    [totalForLaunch]="totalForLaunch"
    [totalPostLaunch]="totalPostLaunch"
    [completedProposals]="completedProposals"
    [totalShortClosed]="totalShortClosed"
    [loading]="dashboardLoading"
    [schemeWiseGrant]="schemeWiseGrant"
    [schemeWiseProposal]="schemeWiseProposal"
    [schemeWisePrelaunch]="schemeWisePrelaunch"
    [schemeWiseForlaunch]="schemeWiseForlaunch"
    [schemeWisePostlaunch]="schemeWisePostlaunch"
    [schemeWiseCompleted]="schemeWiseCompleted">
  </app-summary-metrics>
</section>

<!-- ===== PROPOSAL-WISE STAGE TRACKING TABLE (TDF – no Sub Scheme column) ===== -->
<section class="stage-tracking-section">
  <div class="card stage-tracking-card">
    <div class="card-header section-header-unified d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div>
        <h5 class="mb-0 section-title">Proposal-wise Stage Tracking</h5>
        <small class="text-muted section-subtitle">Status of proposals across major TDF stages</small>
      </div>
      <div class="stage-tracking-legend d-flex align-items-center gap-3 flex-wrap">
        <span class="stage-legend-item"><span class="stage-dot stage-dot-completed"></span> Completed</span>
        <span class="stage-legend-item"><span class="stage-dot stage-dot-progress"></span> In Progress</span>
        <span class="stage-legend-item"><span class="stage-dot stage-dot-pending"></span> Pending</span>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="stage-tracking-toolbar d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 py-2 border-bottom">
        <span class="p-input-icon-left stage-tracking-search-wrap">
          <i class="pi pi-search"></i>
          <input type="text" pInputText class="stage-tracking-search"
            [(ngModel)]="stageTrackingFilters.name"
            (input)="applyStageTrackingFilter()"
            placeholder="Search by proposal title..." />
        </span>
        <button *ngIf="stageTrackingFilters.name" type="button" class="p-button p-button-text p-button-sm"
          (click)="stageTrackingFilters.name=''; applyStageTrackingFilter()" title="Clear search">
          <i class="pi pi-times"></i> Clear
        </button>
      </div>
      <div class="overflow-x-auto overflow-y-auto max-h-[320px]">
        <table class="w-full text-sm stage-tracking-table">
          <thead class="bg-blue-950 sticky top-0 z-10">
            <tr>
              <th class="px-2 py-2 text-white text-left sortable" (click)="sortStageTracking('name')">
                Proposal Title <i class="pi sort-icon" [ngClass]="stageTrackingSortField === 'name' ? (stageTrackingSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
              </th>
              <th class="px-2 py-2 text-white text-left sortable" (click)="sortStageTracking('current_stage')">
                Current Stage <i class="pi sort-icon" [ngClass]="stageTrackingSortField === 'current_stage' ? (stageTrackingSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
              </th>
              <th class="px-2 py-2 text-white text-left sortable" (click)="sortStageTracking('overall_status')">
                Overall Status <i class="pi sort-icon" [ngClass]="stageTrackingSortField === 'overall_status' ? (stageTrackingSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
              </th>
              <th *ngFor="let stage of ['AIP','Feasibility Study','AoN','EOI / PSO','Prototype Development','SSCT','RFP / CNC']" class="px-2 py-2 text-white text-center">{{ stage }}</th>
              <th class="px-2 py-2 text-white text-left sortable" (click)="sortStageTracking('updated_at')">
                Last Updated On <i class="pi sort-icon" [ngClass]="stageTrackingSortField === 'updated_at' ? (stageTrackingSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
              </th>
              <th class="px-2 py-2 text-white text-center sortable" (click)="sortStageTracking('days')">
                Days in Current Stage <i class="pi sort-icon" [ngClass]="stageTrackingSortField === 'days' ? (stageTrackingSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
              </th>
            </tr>
            <tr class="bg-gray-100">
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="stageTrackingFilters.name" (input)="applyStageTrackingFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="stageTrackingFilters.current_stage" (input)="applyStageTrackingFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="stageTrackingFilters.overall_status" (input)="applyStageTrackingFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              <th *ngFor="let _ of [1,2,3,4,5,6,7]" class="p-1"><input class="w-full border rounded px-1 text-xs" placeholder="" readonly /></th>
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="stageTrackingFilters.updated_at" (input)="applyStageTrackingFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="stageTrackingFilters.days" (input)="applyStageTrackingFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr *ngFor="let proposal of stageTablePaginatedData; let i = index" [ngClass]="{ 'bg-white': i % 2 === 0, 'bg-slate-200': i % 2 !== 0 }">
              <td class="px-2 py-1">
                <span class="fw-semibold text-primary pointer" [pTooltip]="proposal.name" (click)="navigateToSchemeTransaction(proposal, activePhaseId)">{{ proposal.name }}</span>
              </td>
              <td class="px-2 py-1"><p-tag [value]="getCurrentStage(proposal)" severity="info" class="p-tag-rounded"></p-tag></td>
              <td class="px-2 py-1">{{ getOverallStatus(proposal) }}</td>
              <td *ngFor="let stageKey of ['AIP','FEASIBILITY','AON','EOI_PSO','PROTOTYPE','SSCT','RFP_CNC']" class="px-2 py-1 text-center">
                <span class="stage-status-dot" [ngClass]="getStageDotClass(getStageStatus(proposal, stageKey))" [pTooltip]="getStageStatus(proposal, stageKey)" tooltipPosition="top"></span>
              </td>
              <td class="px-2 py-1">{{ proposal.updated_at | date:'dd/MM/yyyy' }}</td>
              <td class="px-2 py-1">{{ getDaysInCurrentStage(proposal) }}</td>
            </tr>
            <tr *ngIf="stageTablePaginatedData.length === 0">
              <td colspan="12" class="text-center text-muted py-3"><i class="pi pi-info-circle me-2"></i> No proposal stage data available.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-3 bg-gray-100 border-top text-sm flex-wrap gap-2">
        <div>Showing {{ stageTableStartEntry }} to {{ stageTableEndEntry }} of {{ filteredStageTrackingData.length }} entries</div>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <button type="button" class="px-2 py-1 border rounded" (click)="changeStageTrackingPage(1)">«</button>
          <button type="button" class="px-2 py-1 border rounded" (click)="changeStageTrackingPage(stageTableCurrentPage - 1)">‹</button>
          <button *ngFor="let page of stageTablePages" type="button" class="px-3 py-1 rounded" [class.bg-primary]="page === stageTableCurrentPage" [class.text-white]="page === stageTableCurrentPage" [class.border]="page !== stageTableCurrentPage" (click)="changeStageTrackingPage(page)">{{ page }}</button>
          <button type="button" class="px-2 py-1 border rounded" (click)="changeStageTrackingPage(stageTableCurrentPage + 1)">›</button>
          <button type="button" class="px-2 py-1 border rounded" (click)="changeStageTrackingPage(stageTableTotalPages)">»</button>
        </div>
        <div>
          <select [(ngModel)]="stageTablePageSize" (change)="changeStageTrackingPageSize()" class="border rounded px-2 py-1">
            <option *ngFor="let size of stageTablePageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== ANALYTICS CHARTS ===== -->
<div class="make-dashboard-charts">
  <div class="grid gap-3 mb-3">
    <!-- Proposal Progress Across Major TDF Stages chart hidden as requested
    <div class="col-12">
      <p-card styleClass="make-chart-card make-chart-card-stage-progress">
        <ng-template pTemplate="header">
          <div class="make-chart-header">
            <i class="pi pi-sitemap make-chart-icon"></i>
            <div>
              <h4 class="make-chart-title">Proposal Progress Across Major TDF Stages</h4>
              <p class="make-chart-subtitle">Pending / In Progress / Completed by stage</p>
            </div>
            <button class="p-button p-button-text p-button-rounded" (click)="openFullscreen('stageProgress')" icon="pi pi-window-maximize" pTooltip="Expand"></button>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="make-chart-wrap make-chart-wrap-stage-progress">
            <p-chart type="bar" [data]="stageProgressChart" [options]="stackedBarOptions"></p-chart>
          </div>
        </ng-template>
      </p-card>
    </div>
    -->
  </div>
  <p-dialog [(visible)]="fullscreenVisible" [modal]="true" styleClass="fullscreen-chart-dialog" appendTo="body">
    <ng-template pTemplate="header">
      <h5 class="fw-bold m-0">{{ fullscreenChart.title }}</h5>
    </ng-template>
    <p-chart [type]="fullscreenChart.type" [data]="fullscreenChart.data" [options]="chartOptions"></p-chart>
  </p-dialog>
</div>

<!-- ===== SEEK PROPOSAL RESPONSE ANALYTICS ===== -->
<section class="seek-proposal-analytics-section">
  <p-card styleClass="seek-analytics-card">
    <ng-template pTemplate="header">
      <div class="seek-analytics-header seek-analytics-header-with-filters">
        <div class="seek-analytics-header-text">
          <h3 class="seek-analytics-title">Seek Proposal Response Analytics</h3>
          <p class="seek-analytics-subtitle">Directorate response and proposal generation across seek proposal cycles.</p>
        </div>
        <div class="seek-filters seek-filters-inline seek-filters-row">
          <div class="seek-filter-item">
            <label class="seek-filter-label">From Date</label>
            <p-calendar [(ngModel)]="seekAnalyticsFromDate" [maxDate]="seekAnalyticsToDate || undefined"
              dateFormat="dd M yy" placeholder="From" inputStyleClass="seek-filter-input" [showIcon]="true"
              (onSelect)="onSeekAnalyticsFilterChange()"></p-calendar>
          </div>
          <div class="seek-filter-item">
            <label class="seek-filter-label">To Date</label>
            <p-calendar [(ngModel)]="seekAnalyticsToDate" [minDate]="seekAnalyticsFromDate || undefined"
              dateFormat="dd M yy" placeholder="To" inputStyleClass="seek-filter-input" [showIcon]="true"
              (onSelect)="onSeekAnalyticsFilterChange()"></p-calendar>
          </div>
          <!-- <div class="seek-filter-item">
            <label class="seek-filter-label">Year (optional)</label>
            <p-dropdown [options]="seekAnalyticsYearOptions" [(ngModel)]="seekAnalyticsYear"
              placeholder="All years" optionLabel="label" optionValue="value" [showClear]="true"
              styleClass="seek-filter-input" (onChange)="onSeekAnalyticsFilterChange()"></p-dropdown>
          </div> -->
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="seek-analytics-inner">
        <div class="seek-kpi-chart-row">
          <div class="seek-kpi-cards-group">
            <div class="seek-kpi-card-top seek-kpi-accent-blue">
              <div class="d-flex align-items-center gap-2">
                <span class="seek-kpi-icon-wrap"><i class="pi pi-calendar"></i></span>
                <div>
                  <div class="seek-kpi-label-top">Seek Cycles in Selected Period</div>
                  <div class="seek-kpi-value-top">{{ seekAnalyticsKpis.seekCycles }}</div>
                </div>
              </div>
            </div>
            <div class="seek-kpi-card-top seek-kpi-accent-teal">
              <div class="d-flex align-items-center gap-2">
                <span class="seek-kpi-icon-wrap"><i class="pi pi-building"></i></span>
                <div>
                  <div class="seek-kpi-label-top">Total Directorates Involved</div>
                  <div class="seek-kpi-value-top">{{ seekAnalyticsKpis.totalDirectorates }}</div>
                </div>
              </div>
            </div>
            <div class="seek-kpi-card-top seek-kpi-accent-green">
              <div class="d-flex align-items-center gap-2">
                <span class="seek-kpi-icon-wrap"><i class="pi pi-file-edit"></i></span>
                <div>
                  <div class="seek-kpi-label-top">Total Proposals Generated</div>
                  <div class="seek-kpi-value-top">{{ seekAnalyticsKpis.totalProposals }}</div>
                </div>
              </div>
            </div>
            <div class="seek-kpi-card-top seek-kpi-accent-amber">
              <div class="d-flex align-items-center gap-2">
                <span class="seek-kpi-icon-wrap"><i class="pi pi-percentage"></i></span>
                <div>
                  <div class="seek-kpi-label-top">Overall Directorate Response Rate (%)</div>
                  <div class="seek-kpi-value-top">{{ seekAnalyticsKpis.responseRate }}%</div>
                </div>
              </div>
            </div>
          </div>
          <div class="seek-doughnut-side">
            <p-card styleClass="seek-chart-card seek-doughnut-card-inline">
              <ng-template pTemplate="content">
                <h4 class="seek-chart-title">Overall Directorate Response Summary</h4>
                <p class="seek-chart-desc text-sm text-color-secondary mb-2">Executive summary of overall response distribution.</p>
                <div class="seek-doughnut-wrap seek-doughnut-inline">
                  <p-chart type="doughnut" [data]="seekResponseSummaryDoughnutChart" [options]="seekDoughnutOptions"></p-chart>
                  <div class="seek-doughnut-center" *ngIf="seekAnalyticsKpis.totalResponses > 0">
                    <span class="seek-doughnut-total">{{ seekAnalyticsKpis.totalResponses }}</span>
                    <span class="seek-doughnut-label">Total Responses</span>
                  </div>
                </div>
              </ng-template>
            </p-card>
          </div>
        </div>
        <div class="seek-chart-row seek-directorate-response-chart">
          <p-card styleClass="seek-chart-card">
            <ng-template pTemplate="content">
              <h4 class="seek-chart-title">Directorate Response by Seek Cycle</h4>
              <p class="seek-chart-desc text-sm text-color-secondary mb-2">Participation behaviour of directorates for each seek cycle.</p>
              <div class="seek-bar-chart-wrap">
                <p-chart type="bar" [data]="seekDirectorateResponseChart" [options]="seekStackedBarOptions"></p-chart>
              </div>
            </ng-template>
          </p-card>
        </div>
      </div>
    </ng-template>
  </p-card>
</section>

<!-- ===== SEEK PROPOSAL TABLE: same structure as MAKE scheme (DOI Seek Proposals, Date Extended, Remarks view full, Directorates view all); data from TDF APIs ===== -->
<section class="seek-proposal-data-section" *ngIf="canViewSeekProposalDataTable">
  <div class="card proposal-data-card">
    <div class="card-header section-header-unified d-flex justify-content-between align-items-center">
      <div>
        <h5 class="mb-0 section-title">DOI Seek Proposals: Directorate Responses &amp; Last Submission Dates</h5>
        <small class="text-muted section-subtitle">When DOI sought proposals from directorates—last submission dates and which directorates have responded.</small>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="overflow-x-auto overflow-y-auto max-h-[320px]">
        <table class="w-full text-sm proposal-data-table">
          <thead class="bg-blue-950 sticky top-0 z-10">
            <tr>
              <th class="px-2 py-2 text-white text-center sortable" (click)="sortSeekProposal('end_date')">
                Last Submission Date <i class="pi sort-icon" [ngClass]="seekTableSortField === 'end_date' ? (seekTableSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
              </th>
              <th class="px-2 py-2 text-white text-center">Date Extended</th>
              <th class="px-2 py-2 text-white text-left sortable" (click)="sortSeekProposal('remark')">
                Remarks <i class="pi sort-icon" [ngClass]="seekTableSortField === 'remark' ? (seekTableSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
              </th>
              <th class="px-2 py-2 text-white text-center sortable" (click)="sortSeekProposal('directorate')">
                Directorate <i class="pi sort-icon" [ngClass]="seekTableSortField === 'directorate' ? (seekTableSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
              </th>
              <th class="px-2 py-2 text-white text-center"><i class="pi pi-download me-1"></i> File Download</th>
              <th class="px-2 py-2 text-white text-center"><i class="pi pi-cog me-1"></i> Actions</th>
            </tr>
            <tr class="bg-gray-100">
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="seekTableFilters.end_date" (input)="applySeekProposalFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="seekTableFilters.date_extended" (input)="applySeekProposalFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="seekTableFilters.remark" (input)="applySeekProposalFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="seekTableFilters.directorate" (input)="applySeekProposalFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              <th class="p-1"></th>
              <th class="p-1"></th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
        <tr *ngFor="let proposal of seekTablePaginatedData; let rowIndex = index" class="table-data-row" [class.even-row]="rowIndex % 2 === 0">
          <td class="text-center">
            <span class="date-badge">{{ proposal.end_date | date:'dd MMM yyyy' }}</span>
          </td>
          <td class="text-center date-extended-cell">
            <ng-container *ngIf="isDateExtended(proposal); else notExtended">
              <span class="date-extended-yes">Yes</span>
              <div class="date-extended-dates">
                <span *ngFor="let d of getExtendedDatesList(proposal)" class="date-extended-date-item">{{ d }}</span>
              </div>
            </ng-container>
            <ng-template #notExtended>
              <span class="date-extended-no">No</span>
            </ng-template>
          </td>
          <td class="proposal-remark">
            <div class="remark-cell-wrap">
              <span class="remark-text"
                [class.cell-placeholder]="(getRemarksDisplay(proposal.remark) || '') === '—' || !(proposal.remark || '').trim()"
                [pTooltip]="hasLongRemark(proposal.remark) ? null : getRemarkTooltip(proposal.remark)"
                tooltipPosition="left"
                appendTo="body"
                tooltipStyleClass="remark-tooltip">
                {{ getRemarksDisplay(proposal.remark) || '—' }}
              </span>
              <button *ngIf="hasLongRemark(proposal.remark)" type="button"
                class="p-button p-button-text p-button-sm remark-view-full"
                (click)="showFullRemark($event, proposal.remark)" title="View full remark">
                <i class="pi pi-eye"></i> View full
              </button>
            </div>
          </td>
          <td class="text-center directorate-cell">
            <div class="directorate-text-container">
              <span class="directorate-names" [class.cell-placeholder]="getDirectorateDisplayText(proposal.directorate) === '-'">{{ getDirectorateDisplayText(proposal.directorate) || '—' }}</span>
              <button *ngIf="getDirectorateCount(proposal.directorate) > 3" type="button"
                class="p-button p-button-text p-button-sm directorate-view-all"
                (click)="showDirectorateList($event, proposal.directorate)" title="View all directorates">
                <i class="pi pi-list"></i> View all ({{ getDirectorateCount(proposal.directorate) }})
              </button>
            </div>
          </td>
          <td class="text-center">
            <button class="file-download-btn" (click)="viewUploadedDocuments(proposal)" title="View Documents"
              [disabled]="!proposal.hasDocuments">
              <i class="pi pi-download"></i>
            </button>
          </td>
          <td class="text-center">
            <div class="action-buttons">
              <button class="action-btn menu-btn" (click)="actionMenu.toggle($event)" title="Actions Menu">
                <i class="pi pi-ellipsis-v"></i>
              </button>
              <p-overlayPanel #actionMenu styleClass="action-menu-overlay" [showCloseIcon]="false">
                <ul class="action-list">
                  <li class="mb-2">
                    <button class="p-button p-button-text w-100 d-flex align-items-center justify-content-start gap-2"
                      (click)="viewReceivedProposals(proposal); actionMenu.hide()">
                      <i class="pi pi-inbox"></i> Received Proposals
                    </button>
                  </li>
                  <li class="mb-2">
                    <button class="p-button p-button-text w-100 d-flex align-items-center justify-content-start gap-2"
                      (click)="viewUploadedDocuments(proposal); actionMenu.hide()">
                      <i class="pi pi-file-pdf"></i> View Documents
                    </button>
                  </li>
                  <li class="mt-2">
                    <button class="p-button p-button-text w-100 d-flex align-items-center justify-content-start gap-2"
                      (click)="openEditSeekProposal(proposal); actionMenu.hide()">
                      <i class="pi pi-pencil"></i> Edit Seek Proposal
                    </button>
                  </li>
                  <li class="mt-2">
                    <button class="p-button p-button-text w-100 d-flex align-items-center justify-content-start gap-2"
                      (click)="openEditSeekProposalNilReturns(proposal); actionMenu.hide()">
                      <i class="pi pi-pencil"></i> NIL Returns
                    </button>
                  </li>
                </ul>
              </p-overlayPanel>
            </div>
          </td>
        </tr>
        <tr *ngIf="seekTablePaginatedData.length === 0">
          <td colspan="6" class="text-center empty-state py-3">
            <i class="pi pi-inbox empty-icon"></i>
            <h6 class="mt-2">No proposal data available</h6>
            <p class="text-muted mb-0">No proposals have been created yet.</p>
          </td>
        </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-3 bg-gray-100 border-top text-sm flex-wrap gap-2">
        <div>Showing {{ seekTableStartEntry }} to {{ seekTableEndEntry }} of {{ filteredProposalDataList?.length ?? 0 }} entries</div>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <button type="button" class="px-2 py-1 border rounded" (click)="changeSeekProposalPage(1)">«</button>
          <button type="button" class="px-2 py-1 border rounded" (click)="changeSeekProposalPage(seekTableCurrentPage - 1)">‹</button>
          <button *ngFor="let page of seekTablePages" type="button" class="px-3 py-1 rounded" [class.bg-primary]="page === seekTableCurrentPage" [class.text-white]="page === seekTableCurrentPage" [class.border]="page !== seekTableCurrentPage" (click)="changeSeekProposalPage(page)">{{ page }}</button>
          <button type="button" class="px-2 py-1 border rounded" (click)="changeSeekProposalPage(seekTableCurrentPage + 1)">›</button>
          <button type="button" class="px-2 py-1 border rounded" (click)="changeSeekProposalPage(seekTableTotalPages)">»</button>
        </div>
        <div>
          <select [(ngModel)]="seekTablePageSize" (change)="changeSeekProposalPageSize()" class="border rounded px-2 py-1">
            <option *ngFor="let size of seekTablePageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>
      </div>
    </div>
    <p-overlayPanel #directoratePanel styleClass="directorate-panel-overlay" [showCloseIcon]="true" appendTo="body">
      <div class="directorate-panel-content">
        <h6 class="mb-2">Directorates ({{ selectedDirectorateList.length }})</h6>
        <ul class="directorate-panel-list">
          <li *ngFor="let d of selectedDirectorateList">{{ d.name }}</li>
        </ul>
      </div>
    </p-overlayPanel>
    <p-overlayPanel #remarkPanel styleClass="remark-panel-overlay" [showCloseIcon]="true" appendTo="body">
      <div class="remark-panel-content">
        <h6 class="mb-2">Remarks</h6>
        <div class="remark-panel-text">{{ selectedRemarkFullText || '—' }}</div>
      </div>
    </p-overlayPanel>
  </div>
</section>

<div class="dashboard-container">
  <!-- <button mat-raised-button color="primary" (click)="displayDialog = true">Seek Proposal</button> -->
  <!-- <div class="header">
    <h1>Challenge Management Dashboard</h1>
    <button class="seek-proposal-btn" (click)="displayDialog = true">
      <i class="pi pi-plus"></i>
      Seek Proposal
    </button> -->
  <!-- <div class="role-selector">
      <div class="role-tabs">
        <button class="role-tab" [class.active]="currentRole === 'apso'" (click)="switchRole('apso')">
          APSO
        </button>
        <button class="role-tab" [class.active]="currentRole === 'doi'" (click)="switchRole('doi')">
          DOI
        </button>
        <button class="role-tab" [class.active]="currentRole === 'tdac'" (click)="switchRole('tdac')">
          TDAC
        </button>
        <button class="role-tab" [class.active]="currentRole === 'vcns'" (click)="switchRole('vcns')">
          VCNS
        </button>
      </div>
    </div> -->
  <!-- </div> -->

  <!-- Stats -->
  <!-- <div class="stats-container">
    <div class="stat-card">
      <div class="stat-number">{{ stats.total }}</div>
      <div class="stat-label">Total Proposals</div>
    </div>
    <div class="stat-card">
      <div class="stat-number">{{ stats.pending }}</div>
      <div class="stat-label">Pending Review</div>
    </div>
    <div class="stat-card">
      <div class="stat-number">{{ stats.screening }}</div>
      <div class="stat-label">Under Screening</div>
    </div>
    <div class="stat-card">
      <div class="stat-number">{{ stats.approved }}</div>
      <div class="stat-label">Approved</div>
    </div>
  </div> -->

  <!-- <div class="fluid-container">
    <div class="row">
    <div class="col-12">
      <div class="card-body">
        <div class="nav-tabs mb-3">
          <p-tabView [(activeIndex)]="activeTabIndex" class="nav-tab me-2 custom-tabview" (onChange)="onTabChange($event)">
            <p-tabPanel header="Pending Work">
              <div class="card-body" *ngIf="activeTabIndex === 0">
                <div class="table-responsive p-3">
                  <p-table #dt [value]="proposalData" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    [rowsPerPageOptions]="[5, 10, 20, 50]" [lazy]="lazy" [totalRecords]="totalCount"
                    (onPage)="onPageChange($event)"
                    [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
                    [scrollable]="true" [(selection)]="selectedProposals" scrollDirection="both"
                    [resizableColumns]="true" [reorderableColumns]="true"
                    [globalFilterFields]="['name','description','proposal_status','created_by.first_name','created_by.last_name']"
                    dataKey="id" class="p-datatable-sm complex-proposal-table">
                    <ng-template pTemplate="header">
                      <tr>
                        <ng-container *ngFor="let column of tableColumns">
                          <th (click)="lazy=false" [pSortableColumn]="column.field" pResizableColumn
                            class="sortable-column">
                            <ng-container [ngSwitch]="column.field">
                              <ng-container *ngSwitchCase="'checkbox'">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <span>{{ column.header }}</span>
                              </ng-container>
                            </ng-container>

                            <p-columnFilter class="text-gray-600" *ngIf="column.filter" [type]="column.filterType" [field]="column.field"
                              display="menu" [showMatchModes]="true" [showOperator]="false"
                              [showAddButton]="false"></p-columnFilter>
                          </th>
                        </ng-container>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-proposal>
                      <tr [ngClass]="{ 'table-row-hover': true }">
                        <ng-container *ngFor="let column of tableColumns">
                          <td class="align-middle text-nowrap">
                            <ng-container [ngSwitch]="column.field">
                              <ng-container *ngSwitchCase="'checkbox'">
                                <p-tableCheckbox [value]="proposal" selectionMode="multiple"></p-tableCheckbox>
                              </ng-container>

                              <ng-container *ngSwitchCase="'name'">
                                <span class="fw-semibold text-primary pointer" pTooltip="{{ proposal.name }}"
                                  (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                  {{ proposal.name }}
                                </span>
                              </ng-container>

                              <ng-container *ngSwitchCase="'description'">
                                <span class="text-muted text-truncate d-inline-block" style="max-width: 250px;"
                                  [pTooltip]="proposal.description">
                                  {{ proposal.description }}
                                </span>
                              </ng-container>

                              <ng-container *ngSwitchCase="'steps'">
                                <span class="badge bg-info text-dark">
                                  {{ proposal.step_summary?.completed_steps || 0 }}/{{
                                  proposal.step_summary?.total_steps || 0 }}
                                </span>
                              </ng-container>

                              <ng-container *ngSwitchCase="'progress'">
                                <div class="progress" style="height: 8px;">
                                  <div class="progress-bar bg-success"
                                    [style.width.%]="proposal.step_summary?.completed_percentage || 0"></div>
                                </div>
                                <small class="text-muted">{{ proposal.step_summary?.completed_percentage || 0
                                  }}%</small>
                              </ng-container>

                              <ng-container *ngSwitchCase="'created_by'">
                                <i class="pi pi-user text-secondary me-1"></i>
                                {{ proposal.created_by?.first_name }} {{ proposal.created_by?.last_name }}
                              </ng-container>

                              <ng-container *ngSwitchCase="'directorate'">
                                <i class="pi pi-building text-secondary me-1"></i>
                                {{ proposal.created_by?.unit?.name }}
                              </ng-container>

                              <ng-container *ngSwitchCase="'proposal_status'">
                                <span class="badge rounded-pill px-3 py-1"
                                  [ngClass]="getStatusBadgeClass(proposal.proposal_status)">
                                  {{ proposal.proposal_status | titlecase }}
                                </span>
                              </ng-container>

                              <ng-container *ngSwitchCase="'actions'">
                                <button pButton type="button" icon="pi pi-ellipsis-v"
                                  class="p-button-rounded p-button-text action-btn"
                                  (click)="op.toggle($event)"></button>
                                <p-overlayPanel #op>
                                  <div class="list-group small">
                                    <a class="list-group-item list-group-item-action pointer"
                                      (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                      Go to Steps
                                    </a>
                                  </div>
                                </p-overlayPanel>
                              </ng-container>

                              <ng-container *ngSwitchDefault>
                                {{ getFieldValue(proposal, column.field) || '-' }}
                              </ng-container>
                            </ng-container>
                          </td>
                        </ng-container>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td [attr.colspan]="tableColumns.length" class="text-center text-muted py-3">
                          <i class="pi pi-info-circle me-2"></i> No proposals found.
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Work Done">
              <div class="card-body" *ngIf="activeTabIndex === 1">
                <div class="table-responsive p-3">
                  <p-table #dt [value]="proposalData" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    [rowsPerPageOptions]="[5, 10, 20, 50]" [lazy]="lazy" [totalRecords]="totalCount"
                    (onPage)="onPageChange($event)"
                    [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
                    [scrollable]="true" [(selection)]="selectedProposals" scrollDirection="both"
                    [resizableColumns]="true" [reorderableColumns]="true"
                    [globalFilterFields]="['name','description','proposal_status','created_by.first_name','created_by.last_name']"
                    dataKey="id" class="p-datatable-sm complex-proposal-table">
                    <ng-template pTemplate="header">
                      <tr>
                        <ng-container *ngFor="let column of tableColumns">
                          <th (click)="lazy=false" [pSortableColumn]="column.field" pResizableColumn
                            class="sortable-column">
                            <ng-container [ngSwitch]="column.field">
                              <ng-container *ngSwitchCase="'checkbox'">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <span>{{ column.header }}</span>
                              </ng-container>
                            </ng-container>

                            <p-columnFilter class="text-gray-600" *ngIf="column.filter" [type]="column.filterType" [field]="column.field"
                              display="menu" [showMatchModes]="true" [showOperator]="false"
                              [showAddButton]="false"></p-columnFilter>
                          </th>
                        </ng-container>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-proposal>
                      <tr [ngClass]="{ 'table-row-hover': true }">
                        <ng-container *ngFor="let column of tableColumns">
                          <td class="align-middle text-nowrap">
                            <ng-container [ngSwitch]="column.field">
                              <ng-container *ngSwitchCase="'checkbox'">
                                <p-tableCheckbox [value]="proposal" selectionMode="multiple"></p-tableCheckbox>
                              </ng-container>

                              <ng-container *ngSwitchCase="'name'">
                                <span class="fw-semibold text-primary pointer" pTooltip="{{ proposal.name }}"
                                  (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                  {{ proposal.name }}
                                </span>
                              </ng-container>

                              <ng-container *ngSwitchCase="'description'">
                                <span class="text-muted text-truncate d-inline-block" style="max-width: 250px;"
                                  [pTooltip]="proposal.description">
                                  {{ proposal.description }}
                                </span>
                              </ng-container>

                              <ng-container *ngSwitchCase="'steps'">
                                <span class="badge bg-info text-dark">
                                  {{ proposal.step_summary?.completed_steps || 0 }}/{{
                                  proposal.step_summary?.total_steps || 0 }}
                                </span>
                              </ng-container>

                              <ng-container *ngSwitchCase="'progress'">
                                <div class="progress" style="height: 8px;">
                                  <div class="progress-bar bg-success"
                                    [style.width.%]="proposal.step_summary?.completed_percentage || 0"></div>
                                </div>
                                <small class="text-muted">{{ proposal.step_summary?.completed_percentage || 0
                                  }}%</small>
                              </ng-container>

                              <ng-container *ngSwitchCase="'created_by'">
                                <i class="pi pi-user text-secondary me-1"></i>
                                {{ proposal.created_by?.first_name }} {{ proposal.created_by?.last_name }}
                              </ng-container>

                              <ng-container *ngSwitchCase="'directorate'">
                                <i class="pi pi-building text-secondary me-1"></i>
                                {{ proposal.created_by?.unit?.name }}
                              </ng-container>

                              <ng-container *ngSwitchCase="'proposal_status'">
                                <span class="badge rounded-pill px-3 py-1"
                                  [ngClass]="getStatusBadgeClass(proposal.proposal_status)">
                                  {{ proposal.proposal_status | titlecase }}
                                </span>
                              </ng-container>

                              <ng-container *ngSwitchCase="'actions'">
                                <button pButton type="button" icon="pi pi-ellipsis-v"
                                  class="p-button-rounded p-button-text action-btn"
                                  (click)="op.toggle($event)"></button>
                                <p-overlayPanel #op>
                                  <div class="list-group small">
                                   
                                    <a class="list-group-item list-group-item-action pointer"
                                      (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                      Go to Steps
                                    </a>
                                  </div>
                                </p-overlayPanel>
                              </ng-container>

                              <ng-container *ngSwitchDefault>
                                {{ getFieldValue(proposal, column.field) || '-' }}
                              </ng-container>
                            </ng-container>
                          </td>
                        </ng-container>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td [attr.colspan]="tableColumns.length" class="text-center text-muted py-3">
                          <i class="pi pi-info-circle me-2"></i> No proposals found.
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
    </div>
  </div> -->
  <!-- Filters -->
  <!-- <div class="controls">
    <div class="control-group">
      <label for="categoryFilter">Category</label>
      <select
        id="categoryFilter"
        class="form-control"
        [(ngModel)]="filters.category"
        (change)="applyFilters()"
      >
        <option value="">All Categories</option>
        <option value="To Move">To Move</option>
        <option value="To Float">To Float</option>
        <option value="To Fight">To Fight</option>
      </select>
    </div>

    <div class="control-group">
      <label for="statusFilter">Status</label>
      <select
        id="statusFilter"
        class="form-control"
        [(ngModel)]="filters.status"
        (change)="applyFilters()"
      >
        <option value="">All Status</option>
        <option value="pending">Pending</option>
        <option value="screening">Under Screening</option>
        <option value="shortlisted">Shortlisted</option>
        <option value="approved">Approved</option>
        <option value="rejected">Rejected</option>
      </select>
    </div>

    <div class="control-group">
      <label for="priorityFilter">Priority</label>
      <select
        id="priorityFilter"
        class="form-control"
        [(ngModel)]="filters.priority"
        (change)="applyFilters()"
      >
        <option value="">All Priorities</option>
        <option value="high">High</option>
        <option value="medium">Medium</option>
        <option value="low">Low</option>
      </select>
    </div>

    <div class="control-group">
      <label>&nbsp;</label>
      <button
        class="btn btn-primary"
        (click)="openRouteModal()"
        [disabled]="selectedChallengeCount?.length < 1"
      >
        Configure Route
      </button>
    </div> -->
  <!-- <div class="control-group">
      <label>&nbsp;</label>
      <button class="btn btn-primary" (click)="displayDialog = true">
        Seek Proposal
      </button>
    </div> -->
  <!-- </div> -->
  <!-- Proposal Details Modal -->
  <p-dialog header="Proposal Details" [(visible)]="detailsModalOpen" [modal]="true" [draggable]="false"
    [resizable]="true" [maximizable]="true" [closable]="true" [style]="{ width: '90vw' }" appendTo="body">
    <!-- <div class="d-flex justify-content-end">
      <button
        class="btn btn-warning btn-sm mt-3"
        (click)="editProposal(selectedProposal, 'edit')"
        [disabled]="currentRole === 'vcns'"
      >
        Edit
      </button>
    </div> -->
    <div class="form-wrapper">
      <form [formGroup]="proposalForm" class="tdf-form ">
        <div class="form">
          <!-- Section: Requirement -->
          <div class=" form-section shadow-sm mb-4 p-3">
            <h3 class="section-title mb-3">Requirement Details</h3>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Title of the Requirement <b class="text-danger">*</b></label>
              <editor [init]="init" formControlName="technologyInsertion" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Description of major system/sub-system and where the item/product is to be
                utilised/fitted <b class="text-danger">*</b></label>
              <editor [init]="init" formControlName="justificationText" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Reason for pursuing project under TDF scheme <b
                  class="text-danger">*</b></label>
              <editor [init]="init" formControlName="exportPotential" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Objective (to cover product/system/Item) <b class="text-danger">*</b></label>
              <editor [init]="init" formControlName="objective" [disabled]="isEditorDisabled"></editor>
            </div>
          </div>

          <!-- Section: System Details -->
          <div class=" form-section shadow-sm mb-4 p-3">
            <h3 class="section-title mb-3">System & Requirements</h3>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Description & Details of existing system and its use</label>
              <editor [init]="init" formControlName="existingSystem" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Functional and Operational requirements in qualitative terms</label>
              <editor [init]="init" formControlName="functionalRequirements" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Contemporary solutions known nationally and/or internationally (if nil, then
                source of idea)</label>
              <editor [init]="init" formControlName="contemporarySolutions" [disabled]="isEditorDisabled"></editor>
            </div>
          </div>

          <!-- Section: Additional Info -->
          <div class=" form-section shadow-sm mb-4 p-3">
            <h3 class="section-title mb-3">Additional Information</h3>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Miscellaneous Information</label>
              <editor [init]="init" formControlName="miscellaneousInfo" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">References</label>
              <editor [init]="init" formControlName="references" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Keywords</label>
              <editor [init]="init" formControlName="keywords" [disabled]="isEditorDisabled"></editor>
            </div>
          </div>

          <!-- Section: Requirement & Testing -->
          <div class=" form-section shadow-sm mb-4 p-3">
            <h3 class="section-title mb-3">Requirements & Testing</h3>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Estimated requirement for the Indian Navy over 03 to 05 years</label>
              <editor [init]="init" formControlName="estimatedRequirement" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Testing Methodology, Free Issue Material, Acceptance Criteria / Type Tests
                Required / Venue of testing</label>
              <editor [init]="init" formControlName="testingMethodology" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Likely Civil Spin Offs</label>
              <editor [init]="init" formControlName="civilSpinOffs" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Technology Readiness Level</label>
              <editor [init]="init" formControlName="technologyReadinessLevel" [disabled]="isEditorDisabled"></editor>
            </div>
          </div>

          <!-- Section: Proposal Details -->
          <div class=" form-section shadow-sm mb-4 p-3">
            <h3 class="section-title mb-3">Proposal Details</h3>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Proposal is an equipment/spare, is it an import substitution / replacement /
                upgradation / new induction. Explain</label>
              <editor [init]="init" formControlName="proposalExplanation" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">QA Agency</label>
              <editor [init]="init" formControlName="qaAgency" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Concurrence by APSO</label>
              <editor [init]="init" formControlName="apsoConcurrence" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">PSQR</label>
              <editor [init]="init" formControlName="psqr" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Additional Information</label>
              <editor [init]="init" formControlName="additionalInformation" [disabled]="isEditorDisabled"></editor>
            </div>

            <div class="form-group mb-4" [class.readonly-editor]="isEditorDisabled">
              <label class="form-label">Quantity Required</label>
              <editor [init]="init" formControlName="qtyRequired" [disabled]="isEditorDisabled"></editor>
            </div>
          </div>

          <!-- Section: File Uploads -->
          <div class="form-section shadow-sm p-3 mb-4">
            <h3 class="section-title mb-3">Document Uploads</h3>

            <!-- Uploaded Photograph -->
            <ng-container *ngIf="selectedProposal?.upload_photograph; else noPhoto">
              <div class="uploaded-files">
                <h5>Uploaded Photograph</h5>
                <ul>
                  <li>
                    <a href="{{ apiUrl + selectedProposal?.upload_photograph }}" target="_blank"
                      rel="noopener noreferrer">
                      {{ getFileName(selectedProposal?.upload_photograph) }}
                    </a>
                  </li>
                </ul>
              </div>
            </ng-container>
            <ng-template #noPhoto>
              <p class="text-muted">No Photograph uploaded.</p>
            </ng-template>

            <!-- Upload Photograph -->
            <div class="upload-field" *ngIf="isEditMode">
              <label for="draftSotr">Upload Photograph <span class="text-danger">*</span></label>
              <p-fileUpload name="draftSotr" #draftSotrUpload [auto]="true" [customUpload]="true" [multiple]="false"
                mode="advanced" [maxFileSize]="209715200"
                accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                (uploadHandler)="onUploadDraftSotr($event)">
                <ng-template #empty>
                  <p>Drag and drop the Photograph here to upload.</p>
                </ng-template>
              </p-fileUpload>

              <!-- Show attached files -->
              <div *ngIf="draftSotrUpload?.files?.length">
                <h5 class="mt-3">Attached Photograph</h5>
                <ul>
                  <li *ngFor="let f of draftSotrUpload.files">{{ f.name }}</li>
                </ul>
              </div>
            </div>

            <hr />

            <!-- Uploaded Supporting Docs -->
            <ng-container *ngIf="selectedProposal?.feasibility_study; else noSupportingDocs">
              <div class="uploaded-files">
                <h5>Uploaded Supporting Documents</h5>
                <ul>
                  <li>
                    <a href="{{ apiUrl + selectedProposal.feasibility_study }}" target="_blank"
                      rel="noopener noreferrer">
                      {{ getFileName(selectedProposal.feasibility_study) }}
                    </a>
                  </li>
                </ul>
              </div>
            </ng-container>
            <ng-template #noSupportingDocs>
              <p class="text-muted">No supporting documents uploaded.</p>
            </ng-template>

            <!-- Upload Supporting Docs -->
            <div class="upload-field" *ngIf="isEditMode">
              <label for="supportingDocs">Supporting Documents <span class="text-danger">*</span></label>
              <!-- <p-fileUpload name="supportingDocs" #fileUpload [customUpload]="true" [multiple]="true" mode="advanced"
                (uploadHandler)="onUploadSupportingDocs($event)" [auto]="true" [maxFileSize]="209715200"
                accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                <ng-template #empty>
                  <p>Drag and drop supporting documents here to upload.</p>
                </ng-template>
              </p-fileUpload> -->
              <app-upload-document></app-upload-document>

              <div *ngIf="fileUpload?.files?.length">
                <h5 class="mt-3">Attached Supporting Documents</h5>
                <ul>
                  <li *ngFor="let f of fileUpload.files">{{ f.name }}</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
        <div class="d-flex justify-content-end">
          <button type="submit" class="btn btn-primary" *ngIf="isEditMode" (click)="onSubmitData()">Submit</button>
        </div>
      </form>
    </div>
  </p-dialog>

  <p-dialog header="Configure Route" [(visible)]="routeModal" [modal]="true" [style]="{ width: '70vw' }" appendTo="body"
    [maximizable]="true">
    <!-- Selected challenges -->
    <h5 class="mt-3 mb-2">Selected Challenges</h5>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Challenge Name</th>
          <th>Title</th>
          <th>Category</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let challenge of selectedChallenges">
          <td>{{ challenge.proposal_name }}</td>
          <td>{{ challenge.title }}</td>
          <td>{{ challenge.category }}</td>
        </tr>
      </tbody>
    </table>

    <div class="mt-3">
      <div class="card-header mb-2">
        <h5 class="mb-0">Approval Remarks</h5>
      </div>
      <p-floatLabel variant="in" class="mt-2 w-100">
        <textarea pInputTextarea id="DocName" rows="4" [(ngModel)]="IRAremarks" autocomplete="off"
          class="w-100"></textarea>
        <!-- <label for="DocName">Comments</label> -->
      </p-floatLabel>
    </div>

    <!-- Dropdowns -->
    <form [formGroup]="routeForm" class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-6 mb-3 px-3">
          <label>Role</label>
          <p-dropdown [options]="roleList" formControlName="role" optionValue="id" optionLabel="name" [filter]="true"
            filterBy="name" placeholder="Select a Role" class="w-100" (onChange)="onRoleChange($event)" appendTo="body">
          </p-dropdown>
        </div>
        <div class="col-md-6 mb-3 px-3">
          <label>Directorate</label>
          <p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
            placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)" [filter]="true"
            filterBy="name" appendTo="body">
          </p-dropdown>
        </div>
      </div>
      <div class="col-md-6 mb-3 px-3">
        <label>User</label>
        <p-dropdown [options]="userList" formControlName="user" optionValue="id" optionLabel="first_name"
          placeholder="Select a User" class="w-100" [filter]="true" filterBy="first_name" appendTo="body"
          (onChange)="onUserChange($event)">
          <ng-template let-user pTemplate="item">
            <div class="list-group-item list-group-item-action">
              {{ user.first_name }} {{ user.last_name }} -
              <small>{{ user.loginname }}</small>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </form>

    <!-- Footer -->
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary me-4" (click)="routeModal = false">
        Cancel
      </button>
      <button class="btn btn-success" (click)="submitIRA(); onrouteFormSubmit()">
        Save
      </button>
    </div>
  </p-dialog>

  <!-- Seek Proposal -->
  

   <p-dialog header="Seek Proposal" [(visible)]="displayDialog" [modal]="true" [draggable]="false" [resizable]="true"
    [maximizable]="true" [closable]="true" [style]="{width: '60vw'}" class="add-scheme-dialog" appendTo="body">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="row mt-3 mb-3">
        <div class="d-flex justify-content-between gap-3">
          <!-- Start Date -->
          <!-- <div class="w-50 mt-3 mb-3">
            <label for="startDate" class="form-label">Start Date <b class="text-danger">*</b></label>
            <input type="date" id="startDate" formControlName="startDate" class="form-control"
              [class.is-invalid]="isFieldInvalid('startDate')" (change)="onStartDateChange($event)" />
            <div class="text-danger mt-1" *ngIf="isFieldInvalid('startDate')">
              {{ getFieldError("startDate") }}
            </div>
          </div> -->

          <!-- End Date -->
          <div class="w-50 mt-3 mb-3">
            <label for="lastDate" class="form-label">Last Submission Date <b class="text-danger">*</b></label>
            <input type="date" id="lastDate" formControlName="lastDate" class="form-control"
              [class.is-invalid]="isFieldInvalid('lastDate')" 
              [min]="userForm.get('startDate')?.value" />
            <div class="text-danger mt-1" *ngIf="isFieldInvalid('lastDate')">
              {{ getFieldError("lastDate") }}
            </div>
          </div>
          <!-- Extension Section (Only for MAKE_ADMIN) -->
          <!-- <div class="col-md-12 mt-3 mb-3" *ngIf="loginName === 'make_admin'">

            <label class="form-label fw-bold">Submission Extension</label>

            <div class="d-flex gap-3 align-items-center">

              <input type="date" [(ngModel)]="extensionDate" class="form-control w-50"
                [min]="userForm.get('endDate')?.value" [disabled]="extensionCount >= 2" />

              <button type="button" class="btn btn-warning" (click)="extendSubmissionDate()"
                [disabled]="extensionCount >= 2">

                Extend Date

              </button>

            </div>

            <small class="text-muted">
              Maximum 2 extensions allowed
            </small>

          </div> -->
          <!-- <div  class="mt-3">

  <label class="fw-bold">Extension History</label>

  <ul class="list-group mt-2">

    <li class="list-group-item" *ngFor="let ext of extensionHistory">
      Extended To : {{ ext.date | date:'dd-MM-yyyy' }}
      <span class="text-muted ms-2">
        by {{ ext.extendedBy }}
      </span>
    </li>

  </ul>

</div> -->
        </div>

        <!-- User Selection -->
        <div class="col-md-12 mt-3 mb-3">
          <label for="directorate" class="form-label">
            Professional Directorate <span class="text-danger">*</span>
          </label>
          <div class="d-flex gap-2 align-items-end">
            <div class="flex-grow-1">
              <p-multiSelect id="directorate" formControlName="directorate" [options]="unitList" optionLabel="name"
                optionValue="id" placeholder="Select professional directorates..." [style]="{'width':'100%'}"
                [class.is-invalid]="isFieldInvalid('directorate')" [filter]="true" filterBy="name" display="chip"
                [showToggleAll]="true" appendTo="body">
              </p-multiSelect>
            </div>
            <!-- <button type="button" class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
              (click)="openAddDirectorateModal()" title="Add New Directorate">
              <i class="pi pi-plus"></i>
              <span class="d-none d-md-inline">Add New</span>
            </button> -->
          </div>
          <div class="text-danger mt-1" *ngIf="isFieldInvalid('directorate')">
            {{ getFieldError("directorate") }}
          </div>
          <!-- <small class="text-muted">
            <i class="pi pi-info-circle me-1"></i>
            Can't find your directorate? Click "Add New" to create one.
          </small> -->

          <!-- Selected User Preview -->
          <!-- <div class="card mt-3 p-3" *ngIf="userForm.get('selectedUser')?.value">
          <h6>{{ getSelectedUserName() }}</h6>
          <p>{{ getSelectedUserEmail() }}</p>
          <span class="badge bg-info">{{ getSelectedUserDepartment() }}</span>
        </div> -->
        </div>

        <!-- Remarks -->
        <div class="col-md-12 mt-3 mb-3">
          <label for="remarks" class="form-label">Remarks <b class="text-danger">*</b></label>
          <textarea id="remarks" formControlName="remarks" rows="5" class="form-control"
            placeholder="Describe the  scope, objectives, deliverables, timeline, etc..."
            [class.is-invalid]="isFieldInvalid('remarks')"></textarea>
          <div class="text-danger mt-1" *ngIf="isFieldInvalid('remarks')">
            {{ getFieldError("remarks") }}
          </div>
          <div class="text-muted text-end">
            {{ userForm.get("remarks")?.value?.length || 0 }}/500
          </div>
        </div>
      </div>
      <!-- File Upload Section -->
<div class="col-md-12 mt-3 mb-3">
  <label class="form-label">Attach Documents </label>

  <!-- Drop Zone -->
  <div
    class="upload-dropzone"
    [class.dragover]="isDragging"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()">
    <input
      #fileInput
      type="file"
      multiple
      accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
      style="display:none"
      (change)="onFileSelected($event)" />
    <div class="upload-dropzone-content">
      <i class="pi pi-cloud-upload upload-icon"></i>
      <p class="mb-1 fw-semibold">Drag & drop files here</p>
      <p class="text-muted small mb-2">or click to browse</p>
      <span class="badge bg-light text-secondary border">
        PDF, DOC, DOCX, XLS, XLSX, PNG, JPG &nbsp;
      </span>
    </div>
  </div>

  <!-- File Preview List -->
  <div class="file-preview-list mt-3" *ngIf="selectedFiles.length > 0">
    <div
      class="file-preview-item d-flex align-items-center gap-2 p-2 mb-2 border rounded"
      *ngFor="let file of selectedFiles; let i = index">

      <!-- File Icon -->
      <div class="file-icon-wrap">
        <i [class]="getFileIcon(file.name)" class="file-type-icon"></i>
      </div>

      <!-- File Info -->
      <div class="flex-grow-1 overflow-hidden">
        <div class="file-name text-truncate fw-medium small">{{ file.name }}</div>
        <div class="text-muted" style="font-size:11px">{{ formatFileSize(file.size) }}</div>
      </div>

      <!-- Remove Button -->
      <button
        type="button"
        class="btn btn-sm btn-outline-danger border-0 p-1"
        (click)="removeFile(i)"
        title="Remove file">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
</div>
      <footer class="d-flex justify-content-end mt-4 gap-3">
        <button type="submit" class="btn btn-primary" [disabled]="isLoading || userForm.invalid">
          <span *ngIf="!isLoading">Submit</span>
          <span *ngIf="isLoading">Processing Request...</span>
        </button>
      </footer>
    </form>

    <!-- Footer -->
    <!-- <footer class="d-flex justify-content-end mt-4 gap-3">
    <button type="submit" class="btn btn-primary" [disabled]="isLoading || userForm.invalid">
      <span *ngIf="!isLoading">Submit</span>
      <span *ngIf="isLoading">Processing Request...</span>
    </button>
  </footer> -->
  </p-dialog>

  <!-- Edit Proposal Modal -->


   <p-dialog header="Edit Proposal" [(visible)]="editProposalModal" [modal]="true" [draggable]="false" [resizable]="true"
    [maximizable]="true" [closable]="true" [style]="{width: '60vw'}" appendTo="body">

    <form [formGroup]="proposalEditForm" (ngSubmit)="saveEditedProposal()">
      <div class="row mt-3 mb-3">
        <!-- Start Date -->
        <div class="d-flex gap-3">
          <!-- <div class="w-50 mt-3 mb-3">
            <label for="editStartDate" class="form-label">
              Start Date <b class="text-danger">*</b>
            </label>
            <input type="date" id="editStartDate" formControlName="start_date" class="form-control"
              [class.is-invalid]="proposalEditForm.get('start_date')?.invalid && proposalEditForm.get('start_date')?.touched" />
            <div class="text-danger mt-1"
              *ngIf="proposalEditForm.get('start_date')?.invalid && proposalEditForm.get('start_date')?.touched">
              Start Date is required
            </div>
          </div> -->

          <!-- End Date -->
          <div class="w-50 mt-3 mb-3">
            <label for="editEndDate" class="form-label">
              Last submission Date <b class="text-danger">*</b>
            </label>
            <input type="date" id="editEndDate" formControlName="end_date" class="form-control"
              [class.is-invalid]="proposalEditForm.get('end_date')?.invalid && proposalEditForm.get('end_date')?.touched"
              [min]="proposalEditForm.get('start_date')?.value" />
            <div class="text-danger mt-1"
              *ngIf="proposalEditForm.get('end_date')?.invalid && proposalEditForm.get('end_date')?.touched">
              End Date is required
            </div>
          </div>
        </div>

        <!-- Directorate Selection -->
        <div class="col-md-12 mt-3 mb-3">
          <label for="editDirectorate" class="form-label">
            Professional Directorate <span class="text-danger">*</span>
          </label>
          <div class="d-flex gap-2 align-items-end">
            <div class="flex-grow-1">
              <p-multiSelect id="editDirectorate" formControlName="directorate" [options]="unitList" optionLabel="name"
                optionValue="id" optionValue="id" placeholder="Select professional directorates..."
                [style]="{'width':'100%'}"
                [class.is-invalid]="proposalEditForm.get('directorate')?.invalid && proposalEditForm.get('directorate')?.touched"
                [filter]="true" filterBy="name" display="chip" [showToggleAll]="true">
              </p-multiSelect>
            </div>
            <!-- <button type="button" class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
              (click)="openAddDirectorateModal()" title="Add New Directorate">
              <i class="pi pi-plus"></i>
              <span class="d-none d-md-inline">Add New</span>
            </button> -->
          </div>
          <div class="text-danger mt-1"
            *ngIf="proposalEditForm.get('directorate')?.invalid && proposalEditForm.get('directorate')?.touched">
            Professional Directorate is required
          </div>
          <!-- <small class="text-muted">
            <i class="pi pi-info-circle me-1"></i>
            Can't find your directorate? Click "Add New" to create one.
          </small> -->
        </div>

        <!-- Remarks -->
        <div class="col-md-12 mt-3 mb-3">
          <label for="editRemarks" class="form-label">
            Remarks <b class="text-danger">*</b>
          </label>
          <textarea id="editRemarks" formControlName="remark" rows="5" class="form-control"
            placeholder="Describe the scope, objectives, deliverables, timeline, etc..."
            [class.is-invalid]="proposalEditForm.get('remark')?.invalid && proposalEditForm.get('remark')?.touched"></textarea>
          <div class="text-danger mt-1"
            *ngIf="proposalEditForm.get('remark')?.invalid && proposalEditForm.get('remark')?.touched">
            Remarks is required
          </div>
          <div class="text-muted text-end">
            {{ proposalEditForm.get("remark")?.value?.length || 0 }}/500
          </div>
        </div>

        <!-- Submission Extension (Only for MAKE_ADMIN) -->
        <!-- <div class="col-md-12 mt-3 mb-3" *ngIf="loginName === 'make_admin'">
          <label class="form-label fw-bold">Submission Extension</label>
          <div class="d-flex gap-3 align-items-center">
            <input type="date" [(ngModel)]="extensionDate" [ngModelOptions]="{standalone: true}"
              class="form-control w-50" [min]="proposalEditForm.get('end_date')?.value"
              [disabled]="extensionCount >= 2" />
            <button type="button" class="btn btn-warning" (click)="extendSubmissionDate()"
              [disabled]="extensionCount >= 2 || !extensionDate">
              Extend Date
            </button>
          </div>
          <small class="text-muted">
            Extensions used: {{ extensionCount }}/2 — Maximum 2 extensions allowed
          </small>
        </div> -->

        <!-- Submission Extension (Only for MAKE_ADMIN) -->
<div class="col-md-12 mt-3 mb-3" *ngIf="loginName === 'tdf_admin'">
  <label class="form-label fw-bold">Submission Extension</label>
  <div class="d-flex gap-3">

    <!-- Extension Date 1 -->
    <div class="w-50">
      <label class="form-label text-muted mb-1">
        Extension Date 1
        <span *ngIf="extended_date1" class="badge bg-success ms-2">Set</span>
      </label>
      <input
        type="date"
        [(ngModel)]="extended_date1"
        [ngModelOptions]="{standalone: true}"
        class="form-control"
        [min]="proposalEditForm.get('end_date')?.value"
        [disabled]="!!extended_date2"
      />
    </div>

    <!-- Extension Date 2 — only show if extended_date1 already saved from backend -->
    <div class="w-50" *ngIf="extended_date1 && isExtDate1Saved">
      <label class="form-label text-muted mb-1">
        Extension Date 2
        <span *ngIf="extended_date2" class="badge bg-success ms-2">Set</span>
      </label>
      <input
        type="date"
        [(ngModel)]="extended_date2"
        [ngModelOptions]="{standalone: true}"
        class="form-control"
        [min]="extended_date1"
        [disabled]="!!extended_date2 && isExtDate2FromBackend"
      />
    </div>

  </div>
  <small class="text-muted mt-1 d-block">
    <i class="pi pi-info-circle me-1"></i>
    Extensions used: {{ extensionCount }}/2 — Maximum 2 extensions allowed
  </small>
</div>

        <!-- Status -->
        <!-- <div class="col-md-6 mt-3 mb-3">
          <label for="editStatus" class="form-label">
            Status <b class="text-danger">*</b>
          </label>
          <p-dropdown
            id="editStatus"
            formControlName="status"
            [options]="[
              { label: 'Active', value: 1 },
              { label: 'Inactive', value: 0 }
            ]"
            optionLabel="label"
            optionValue="value"
            placeholder="Select Status"
            class="w-100"
            [class.is-invalid]="proposalEditForm.get('status')?.invalid && proposalEditForm.get('status')?.touched">
          </p-dropdown>
          <div class="text-danger mt-1" *ngIf="proposalEditForm.get('status')?.invalid && proposalEditForm.get('status')?.touched">
            Status is required
          </div>
        </div> -->
      </div>

         <!-- ───────────── SEND REMINDER SECTION ───────────── -->
        <div class="col-md-12 mt-3 mb-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <!-- <label class="form-label fw-bold mb-0">
              <i class="pi pi-bell me-2 text-warning"></i>Send Reminder
            </label> -->
            <button
              type="button"
              class="btn btn-warning btn-sm d-flex align-items-center gap-2"
              (click)="toggleReminderPanel()">
              <i class="pi" [ngClass]="showReminderPanel ? 'pi-chevron-up' : 'pi-bell'"></i>
              {{ showReminderPanel ? 'Hide' : 'Send Reminder' }}
            </button>
          </div>

          <!-- Reminder Panel (collapsible) -->
          <div *ngIf="showReminderPanel"
               class="border rounded p-3 bg-light reminder-panel"
               style="border-left: 4px solid #f59e0b !important; animation: slideDown 0.2s ease;">

            <div class="row g-3">

              <!-- Reminder Directorate Multi-Select -->
              <div class="col-md-12">
                <label for="reminderDirectorate" class="form-label">
                  Select Directorate to Remind <span class="text-danger">*</span>
                </label>
                <p-multiSelect
                  id="reminderDirectorate"
                  [(ngModel)]="reminderDirectorates"
                  [ngModelOptions]="{standalone: true}"
                  [options]="unitList"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Select directorate..."
                  [style]="{'width':'100%'}"
                  [filter]="true"
                  filterBy="name"
                  display="chip"
                  [showToggleAll]="true"
                  [class.is-invalid]="reminderSubmitted && (!reminderDirectorates || reminderDirectorates.length === 0)">
                </p-multiSelect>
                <div class="text-danger mt-1"
                  *ngIf="reminderSubmitted && (!reminderDirectorates || reminderDirectorates.length === 0)">
                  Please select at least one directorate.
                </div>
              </div>

              <!-- Reminder Remarks -->
              <div class="col-md-12">
                <label for="reminderRemarks" class="form-label">
                  Reminder Message <span class="text-danger">*</span>
                </label>
                <textarea
                  id="reminderRemarks"
                  [(ngModel)]="reminderMessage"
                  [ngModelOptions]="{standalone: true}"
                  rows="4"
                  class="form-control"
                  placeholder="Enter the reminder message to be sent to the selected directorates..."
                  [class.is-invalid]="reminderSubmitted && !reminderMessage?.trim()">
                </textarea>
                <div class="text-danger mt-1"
                  *ngIf="reminderSubmitted && !reminderMessage?.trim()">
                  Reminder message is required.
                </div>
                <div class="text-muted text-end mt-1">
                  {{ reminderMessage?.length || 0 }}/500
                </div>
              </div>

              <!-- Reminder Actions -->
              <div class="col-md-12 d-flex justify-content-end gap-2">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="cancelReminder()">
                  <i class="pi pi-times me-1"></i>Cancel
                </button>
                <button
                  type="button"
                  class="btn btn-warning btn-sm d-flex align-items-center gap-1"
                  (click)="sendReminder()"
                  [disabled]="isSendingReminder">
                  <i class="pi" [ngClass]="isSendingReminder ? 'pi-spin pi-spinner' : 'pi-send'"></i>
                  {{ isSendingReminder ? 'Sending...' : 'Send Reminder' }}
                </button>
              </div>

            </div>
          </div>
        </div>
        <!-- ───────────── END SEND REMINDER SECTION ───────────── -->


      <footer class="d-flex justify-content-end mt-4 gap-3">
        <button type="button" class="btn btn-secondary" (click)="cancelEditProposal()">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="proposalEditForm.invalid">
          Update Proposal
        </button>
      </footer>
    </form>
  </p-dialog>

  <!-- Add Directorate Modal -->
  <!-- <p-dialog 
    header="Add new Directorate" 
    [(visible)]="addDirectorateModal" 
    [modal]="true" 
    [draggable]="false" 
    [resizable]="true"
    [maximizable]="true" 
    [closable]="true" 
    [style]="{width: '50vw'}" 
    appendTo="body">
    
    <form [formGroup]="directorateForm" (ngSubmit)="saveNewDirectorate()">
      <div class="row mt-3 mb-3 g-3">
        
        <div class="col-md-6">
          <label for="directorateName" class="form-label">
            Name<span class="text-danger">*</span>
          </label>
          <input
            type="text"
            id="directorateName"
            formControlName="name"
            class="form-control"
            placeholder="Enter directorate name..."
            [class.is-invalid]="directorateForm.get('name')?.invalid && directorateForm.get('name')?.touched"
          />
          <div class="text-danger mt-1" *ngIf="directorateForm.get('name')?.invalid && directorateForm.get('name')?.touched">
            Name is required
          </div>
        </div>

        <div class="col-md-6">
          <label for="directorateCode" class="form-label">
            Code<span class="text-danger">*</span>
          </label>
          <input
            type="text"
            id="directorateCode"
            formControlName="code"
            class="form-control"
            placeholder="Enter directorate code..."
            [class.is-invalid]="directorateForm.get('code')?.invalid && directorateForm.get('code')?.touched"
          />
          <div class="text-danger mt-1" *ngIf="directorateForm.get('code')?.invalid && directorateForm.get('code')?.touched">
            Code is required
          </div>
        </div>
      </div>
      
      <footer class="d-flex justify-content-end mt-4 gap-3">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="cancelAddDirectorate()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="directorateForm.invalid || isAddingDirectorate"
        >
          <span *ngIf="!isAddingDirectorate">Submit</span>
          <span *ngIf="isAddingDirectorate">Adding...</span>
        </button>
      </footer>
    </form>
  </p-dialog> -->
  <!-- Add Directorate Modal -->
  <p-dialog header="Add new Directorate" [(visible)]="addDirectorateModal" [modal]="true" [draggable]="false"
    [resizable]="true" [maximizable]="true" [closable]="true" [style]="{width: '50vw'}" appendTo="body">

    <form [formGroup]="directorateForm" (ngSubmit)="saveNewDirectorate()">

      <!-- Flexbox row with gap -->
      <div class="d-flex gap-3 mt-3 mb-3">
        <!-- Directorate Name -->
        <div class="flex-fill">
          <label for="directorateName" class="form-label">
            Name<span class="text-danger">*</span>
          </label>
          <input type="text" id="directorateName" formControlName="name" class="form-control"
            placeholder="Enter directorate name..."
            [class.is-invalid]="directorateForm.get('name')?.invalid && directorateForm.get('name')?.touched" />
          <div class="text-danger mt-1"
            *ngIf="directorateForm.get('name')?.invalid && directorateForm.get('name')?.touched">
            Name is required
          </div>
        </div>

        <!-- Directorate Code -->
        <div class="flex-fill">
          <label for="directorateCode" class="form-label">
            Code<span class="text-danger">*</span>
          </label>
          <input type="text" id="directorateCode" formControlName="code" class="form-control"
            placeholder="Enter directorate code..."
            [class.is-invalid]="directorateForm.get('code')?.invalid && directorateForm.get('code')?.touched" />
          <div class="text-danger mt-1"
            *ngIf="directorateForm.get('code')?.invalid && directorateForm.get('code')?.touched">
            Code is required
          </div>
        </div>
      </div>

      <!-- Footer -->
      <footer class="d-flex justify-content-end mt-4 gap-3">
        <button type="button" class="btn btn-secondary" (click)="cancelAddDirectorate()">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="directorateForm.invalid || isAddingDirectorate">
          <span *ngIf="!isAddingDirectorate">Submit</span>
          <span *ngIf="isAddingDirectorate">Adding...</span>
        </button>
      </footer>
    </form>
  </p-dialog>

  <!-- Received Proposals Modal -->
  <p-dialog header="Received Proposals" [(visible)]="receivedProposalsModal" [modal]="true" [draggable]="false"
    [resizable]="true" [maximizable]="true" [closable]="true" [style]="{width: '80vw'}" appendTo="body">

    <div class="received-proposals-container my-3">
      <!-- Loading State -->
      <div *ngIf="isLoadingReceivedProposals" class="text-center py-4">
        <i class="pi pi-spinner pi-spin" style="font-size: 2rem"></i>
        <p class="mt-2">Loading received proposals...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="receivedProposalsError" class="alert alert-danger">
        <i class="pi pi-exclamation-triangle me-2"></i>
        {{ receivedProposalsError }}
      </div>

      <!-- Data Table -->
      <div *ngIf="!isLoadingReceivedProposals && !receivedProposalsError">
        <!-- Unit Names Section (Top of Table) -->
        <!-- <div *ngIf="unitNamesInProposals.length" class="mb-3 px-2">
          <h6>Seek proposal requests sent to the Professional Directorates:</h6>
          <div class="d-flex flex-wrap gap-2 mt-2">
            <span class="badge bg-info text-dark" *ngFor="let name of unitNamesInProposals">
              {{ name }}
            </span>
          </div>
        </div> -->


        <p-table [value]="receivedProposalsList" [paginator]="receivedProposalsList.length > 10" [rows]="10"
          [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[10, 25, 50]" styleClass="received-proposals-table">

          <ng-template pTemplate="header">
            <tr class="table-header-row">

              <!-- <th>
                <i class="pi pi-file-text me-1"></i>Title
              </th> -->
              <th>
                <i class="pi pi-tag me-1"></i>Title
              </th>
              <th>
                <i class="pi pi-clock me-1"></i>Created On
              </th>
              <th>
                <i class="pi pi-user me-1"></i>Directorate
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-proposal let-rowIndex="rowIndex">
            <tr class="table-data-row" [class.even-row]="rowIndex % 2 === 0">

              <!-- <td class="proposal-title">
                <span class="title-text" [title]="getPlainText(proposal.title)" tooltipPosition="top">
                  {{ truncateTitle(proposal.title, 3) }}
                </span>
              </td> -->
              <td class="proposal-name">
                <span class="name-text" [title]="proposal.proposal_name">
                  {{ proposal.proposal_name }}
                </span>
              </td>
              <td class="text-center">
                <span class="date-badge">{{ proposal.created_on | date:'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <span class="directorate-text" [title]="proposal.unit_name">
                  {{ proposal.unit_name }}
                </span>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="text-center empty-state">
                <div class="empty-message">
                  <i class="pi pi-inbox empty-icon"></i>
                  <h6 class="mt-2">No received proposals found</h6>
                  <p class="text-muted">No proposals have been received for this seek proposal yet.</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <footer class="d-flex justify-content-end mt-4">
      <button type="button" class="btn btn-secondary" (click)="closeReceivedProposalsModal()">
        Close
      </button>
    </footer>
  </p-dialog>

  <!-- Document Viewer Modal -->
  <p-dialog header="Uploaded Documents" [(visible)]="documentViewerModal" [modal]="true" [draggable]="false"
    [resizable]="true" [maximizable]="true" [closable]="true" [style]="{width: '80vw'}" appendTo="body">

    <div class="document-viewer-container my-3">
      <!-- Loading State -->
      <div *ngIf="isLoadingDocuments" class="text-center py-4">
        <i class="pi pi-spinner pi-spin" style="font-size: 2rem"></i>
        <p class="mt-2">Loading documents...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="documentViewerError" class="alert alert-danger">
        <i class="pi pi-exclamation-triangle me-2"></i>
        {{ documentViewerError }}
      </div>

      <!-- Documents List -->
      <div *ngIf="!isLoadingDocuments && !documentViewerError">
        <!-- Proposal Info -->
        <div class="proposal-info-card mb-4 p-3 bg-light rounded">
          <h6 class="mb-2">
            <i class="pi pi-file-edit me-2"></i>
            Proposal Information
          </h6>
          <div class="row">
            <div class="col-md-6">
              <p class="mb-1"><strong>Created:</strong> {{ selectedProposalForDocs?.created_on | date:'dd MMM yyyy' }}</p>
              <p class="mb-1"><strong>Last Submission:</strong> {{ selectedProposalForDocs?.end_date | date:'dd MMM yyyy' }}</p>
            </div>
            <div class="col-md-6">
              <p class="mb-1"><strong>Description:</strong> {{ selectedProposalForDocs?.remark }}</p>
            </div>
          </div>
        </div>

        <!-- Documents Grid -->
        <div *ngIf="uploadedDocumentsList.length > 0; else noDocuments" class="documents-grid">
          <div class="row g-4">
            <div *ngFor="let doc of uploadedDocumentsList; let i = index" class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
              <div class="document-card p-3 border rounded h-100 d-flex flex-column">
                <div class="document-header text-center mb-3">
                  <div class="document-icon mb-2">
                    <i [class]="getDocumentIcon(doc.file_name)" style="font-size: 2rem; color: #007bff;"></i>
                  </div>
                  <div class="document-info">
                    <h6 class="document-title mb-1" [title]="doc.file_name" style="font-size: 0.9rem; line-height: 1.3; font-weight: 600;">
                      {{ truncateFileName(doc.file_name, 18) }}
                    </h6>
                    <small class="text-muted d-block" style="font-size: 0.8rem;">
                      {{ getFileExtension(doc.file_name) }}
                    </small>
                    <small class="text-muted d-block" style="font-size: 0.75rem;">
                      {{ doc.uploaded_at | date:'dd MMM yyyy' }}
                    </small>
                  </div>
                </div>
                
                <div class="document-actions mt-auto">
                  <button class="btn btn-primary btn-sm w-100" (click)="downloadDocument(doc)" style="font-size: 0.8rem; padding: 0.4rem 0.8rem; border-radius: 6px;">
                    <i class="pi pi-download me-1"></i> Preview
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noDocuments>
          <div class="empty-state text-center py-5">
            <i class="pi pi-file-empty" style="font-size: 3rem; color: #dee2e6;"></i>
            <h6 class="mt-3 text-muted">No documents uploaded</h6>
            <p class="text-muted">This seek proposal doesn't have any uploaded documents yet.</p>
          </div>
        </ng-template>
      </div>
    </div>

    <footer class="d-flex justify-content-end mt-4">
      <button type="button" class="btn btn-secondary" (click)="closeDocumentViewerModal()">
        Close
      </button>
    </footer>
  </p-dialog>

  <!-- File Download Modal -->
  <!-- <p-dialog 
    header="Uploaded File" 
    [(visible)]="fileDownloadModal" 
    [modal]="true" 
    [closable]="true"
    [style]="{width: '600px'}"
    [draggable]="false"
    [resizable]="false"
    styleClass="file-download-dialog">
    
    <div class="file-download-container">
      <div class="file-list-table">
        <div class="table-header">
          <div class="header-cell">Upload Date</div>
          <div class="header-cell">File Name</div>
          <div class="header-cell">View</div>
        </div>
        
        <div class="table-body" *ngIf="uploadedFilesList.length > 0; else noFiles">
          <div class="table-row" *ngFor="let file of uploadedFilesList">
            <div class="table-cell upload-date">{{ file.uploaded_at | date:'MMM dd, yyyy' }}</div>
            <div class="table-cell file-name">{{ file.file_name }}</div>
            <div class="table-cell view-link">
              <a href="#" (click)="downloadDocument(file); $event.preventDefault()" class="view-link-text">view</a>
            </div>
          </div>
        </div>
        
        <ng-template #noFiles>
          <div class="empty-files-state">
            <div class="empty-message">
              <i class="pi pi-file-empty empty-icon"></i>
              <h6 class="mt-2">No files available</h6>
              <p class="text-muted">No files have been uploaded for this proposal.</p>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </p-dialog> -->
  <p-dialog
  header="Uploaded Documents"
  [(visible)]="fileDownloadModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  [maximizable]="true"
  [closable]="true"
  [style]="{width: '65vw'}"
  appendTo="body">

  <!-- Loading State -->
  <div *ngIf="isLoadingDocuments" class="text-center py-5">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #007bff;"></i>
    <p class="mt-3 text-muted">Loading documents...</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoadingDocuments && uploadedFilesList.length === 0" class="text-center py-5">
    <i class="pi pi-inbox" style="font-size: 3rem; color: #ccc;"></i>
    <h6 class="mt-3 text-muted">No documents uploaded</h6>
    <p class="text-muted small">No files have been attached to this seek proposal.</p>
  </div>

  <!-- Documents Grid -->
  <div *ngIf="!isLoadingDocuments && uploadedFilesList.length > 0" class="p-3">
    <p class class="text-muted mb-3 small">
      <i class="pi pi-info-circle me-1"></i>
      {{ uploadedFilesList.length }} document{{ uploadedFilesList.length > 1 ? 's' : '' }} found. Click any row to download.
    </p>

    <div class="doc-list">
      <div
        *ngFor="let file of uploadedFilesList; let i = index"
        class="doc-item d-flex align-items-center gap-3 p-3 mb-2 border rounded cursor-pointer"
        (click)="downloadDocument(file)"
        style="cursor: pointer; transition: background 0.2s;"
        onmouseenter="this.style.background='#f0f4ff'"
        onmouseleave="this.style.background='white'">

        <!-- Icon -->
        <div class="doc-icon-wrap d-flex align-items-center justify-content-center rounded"
          style="width:44px; height:44px; background:#eef2ff; flex-shrink:0;">
          <i [class]="getDocumentIcon(file.file_name)"
            style="font-size:1.4rem;"
            [ngStyle]="{
              'color': file.file_name.endsWith('.pdf') ? '#e53935' :
                       file.file_name.endsWith('.doc') || file.file_name.endsWith('.docx') ? '#1565c0' :
                       file.file_name.endsWith('.xls') || file.file_name.endsWith('.xlsx') ? '#2e7d32' :
                       file.file_name.endsWith('.png') || file.file_name.endsWith('.jpg') || file.file_name.endsWith('.jpeg') ? '#f57c00' :
                       '#546e7a'
            }">
          </i>
        </div>

        <!-- File Info -->
        <div class="flex-grow-1 overflow-hidden">
          <div class="fw-semibold text-truncate" style="font-size:0.92rem;" [title]="file.file_name">
            {{ file.file_name }}
          </div>
          <div class="text-muted" style="font-size:0.78rem;">
            <span class="text-uppercase">{{ getFileExtension(file.file_name) }}</span>
            <span class="mx-1">·</span>
            <span>Uploaded {{ file.uploaded_at | date:'dd MMM yyyy' }}</span>
          </div>
        </div>

        <!-- Download Button -->
        <button
          class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
          style="flex-shrink:0; font-size:0.8rem;"
          (click)="downloadDocument(file); $event.stopPropagation()">
          <i class="pi pi-download"></i>
          Download
        </button>
      </div>
    </div>
  </div>

  <footer class="d-flex justify-content-end mt-3 pt-3 border-top">
    <button type="button" class="btn btn-secondary" (click)="closeFileDownloadModal()">
      Close
    </button>
  </footer>
</p-dialog>


  <p-dialog
header="Nil Returns"
[(visible)]="editNilReturnModal"
[modal]="true"
[style]="{width:'650px'}"
[draggable]="false"
[resizable]="false"
appendTo="body"
>

<p-table [value]="nilReturnList || []">

<ng-template pTemplate="header">
<tr>
<!-- <th>ID</th> -->
<th>Remark</th>
<!-- <th class="text-center">Actions</th> -->
</tr>
</ng-template>

<ng-template pTemplate="body" let-data>

<tr>

<!-- <td>{{data.id}}</td> -->

<td>

<div *ngIf="selectedNilReturnId !== data.id">
{{data.remark}}
</div>

<div *ngIf="selectedNilReturnId === data.id">
<input pInputText [(ngModel)]="editRemark" class="w-100">
</div>

</td>

<!-- <td class="text-center">

<button
pButton
icon="pi pi-pencil"
class="p-button-text"
(click)="editNilReturn(data)"
></button>

<button
pButton
icon="pi pi-check"
class="p-button-success p-button-text"
*ngIf="selectedNilReturnId === data.id"
(click)="updateNilReturn()"
></button>

<button
pButton
icon="pi pi-trash"
class="p-button-danger p-button-text"
(click)="deleteNilReturn(data)"
></button>

</td> -->

</tr>

</ng-template>

</p-table>

</p-dialog>

</div>